/**
 * 1. Cart display
 * 		- Update cart items 
 *		- Calculate subtotal
 * 2. Add to cart 
 * 3. Remove from cart
 * 4. Shipping
 * 5. Total calculation
 */

var selectedItems = {};
var cartCost = {};

/**
 * 1. Cart display
 *		- Update cart item display
 * 		- Calculate subtotal
 */
function updateCart(selectedItems) { 
	// console.log(selectedItems);
	
	var cartItem = '',
			itemTotal = 0,
			subTotal = 0;
	
	if (selectedItems !== null) {
		if (Object.keys(selectedItems).length > 0) {
			for (var item in selectedItems) {  
				cartItem += '<div class="callout"><div class="row">'+
					'<div class="column shrink"><img src="'+selectedItems[item].image+'"></div>'+
					'<div class="column desc">'+
						'<p class="name">'+selectedItems[item].name+'</p>';

				// Item has additional options
				if ('options' in selectedItems[item]) { 		
					for (var option in selectedItems[item].options) { 				
						cartItem += '<p class="option">' + selectedItems[item].options[option].name + '</p>'+
							'<div class="text-indent">'+
								'<p><span class="grey">Size:</span> '+selectedItems[item].options[option].size+
								'<br><span class="grey">Quantity:</span> '+selectedItems[item].options[option].quantity+
							'</p></div>';
					} 
				}
				// No additional options 
				else {
					cartItem += '<p><span class="grey">Size:</span> '+selectedItems[item].size+
						'<br><span class="grey">Quantity:</span> '+selectedItems[item].quantity+
						'<br><span class="grey">Price: </span> $'+selectedItems[item].cost+'</p>';
				}

				// Calculate subtotal
				itemTotal = (parseFloat(selectedItems[item].cost) * selectedItems[item].quantity)
				subTotal += (parseFloat(selectedItems[item].cost) * selectedItems[item].quantity);  
				
				cartItem += '</div>'+
					'<div class="column shrink price">'+
						'<p class="text-larger"><strong>$'+(Math.round(itemTotal * 100) / 100).toFixed(2)+'</strong></p>'+
						'<button class="remove-from-cart text-larger" type="button" data-sku="'+selectedItems[item].sku+'"><span class="icon_cancel grey"></span></button>'+
					'</div></div></div>';

				$('#cartItems').html(cartItem);
			}
		} else {
			$('#cartItems').html('<div class="callout">No items yet</div>');
		}

		// Update subtotal, tax
		$('#cart #cartSubtotal').html('$'+(Math.round(subTotal * 100) / 100).toFixed(2)); 
		var tax = subTotal * .13;
		$('#cart #cartTax').html('$'+(Math.round(tax * 100) / 100).toFixed(2)); 

		// Save cost
		cartCost.subtotal = subTotal;
		cartCost.tax = tax;
		updateCartTotal();
	}
	// AJAX TO STORE CART DATA IN PHP SESSION (OR SAVE TO LOCALSTORAGE)
}


/**
 * 2. Add to cart
 *		- Save items in selectedItems[] for processing
 */
function getItemInfo(element) {
	var itemInfo = {};
			itemInfo.sku  = element.attr('data-sku');
			itemInfo.name = element.attr('data-name');		
			itemInfo.cost = element.attr('data-cost');
			itemInfo.size = element[0].value;
			itemInfo.dbid = element.attr('data-dbid');

	return itemInfo;
}

$('.add-to-cart').click(function() {	
	var quantity = $(this).parents('fieldset').find('[name^="prod-quantity"]');	
	var size	= $(this).parents('fieldset').find('select[name^="prod-size"]');
	var image = $(this).parents('fieldset').find('.prod-image img')[0].src;

	// Item has additional options
	if (size.length > 1) {
		// Options info
		var options = {};
		for (var i = 0; i < size.length; i++) { 
			var optionInfo = getItemInfo($('option:selected', size[i]));
 			optionInfo.quantity = 1; 
			options[optionInfo.sku] = optionInfo;
		} 

		// Base product info
		var itemInfo = getItemInfo($(this));
		// itemInfo.size = null; 
		itemInfo.quantity = 1; 
		itemInfo.options = options;
		itemInfo.image = image;
		itemInfo.dbid = $(this).attr('data-dbid');

		selectedItems[itemInfo.sku] = itemInfo;
	} else { 
		var itemInfo = getItemInfo($('option:selected', size));
		itemInfo.quantity = quantity[0].value; 
		itemInfo.image = image;

		selectedItems[itemInfo.sku] = itemInfo;
	}  

	// Update cart display
	updateCart(selectedItems);

	// Scroll to top 
	/*$('body,html').animate({ 
		scrollTop: $("#toggle-cart-header").offset().top - 3
	}, 400, function() {
		$("#toggle-cart-header").addClass('animate');
		$("#toggle-cart-header").one('webkitAnimationEnd oanimationend msAnimationEnd animationend',
      function (e) {
        $("#toggle-cart-header").removeClass('animate');
      });
	});*/

});


/**
 * 3. Remove from cart
 *		- Remove items from selectedItems[]
 */
$('#cart').on('click', '.remove-from-cart', function(event) {
	var button = $(event.currentTarget);
	var cartId = button.attr('data-sku');
 	
 	if (cartId in selectedItems) { 
 		delete selectedItems[cartId]; 
 	} 
 
	// Update cart display
	updateCart(selectedItems); 
});


/**
 * 4. Shipping
 *		- Update shipping cost cart display
 * 		- Calculate shipping cost
 */
function getShippingCost(val) {	
	// console.log('val: ' +val);
	$.ajax({                                      
		url: 'inc/processing/shippingcost.php',               
		type: 'post',
		data: {'province': val},                        
		dataType: 'json',                
		success: function(data, textStatus, jqXHR) {
			// console.log(data);
			$('#cart #cartShipping').html('$'+data.x_freight);
			cartCost.shipping = parseFloat(data.x_freight);
			updateCartTotal();
			// return data.x_freight;
		},
		error: function(jqXHR, textStatus, error) {
			console.log(textStatus, error);
		}
	});
}

$('#delivery_method').change(function() {
	if ($(this).val() == 'ship') {
		$('#delivery_state').removeClass('hide');
	} else {
		$('#delivery_state').val('');
		$('#delivery_state').addClass('hide');
		$('#cart #cartShipping').html('$0.00');
		cartCost.shipping = 0;
		updateCartTotal();
	}
});

$('#delivery_state').change(function() {
	getShippingCost($(this).val());	
});


/**
 * 5. Calculate total cost
 */
function updateCartTotal() {
	// console.log(cartCost);
	var shippingDefault = ('shipping' in cartCost) ? cartCost.shipping : 0;
	var total = cartCost.subtotal + cartCost.tax + shippingDefault;
	$('#cart #cartTotal').html('$'+(Math.round(total * 100) / 100).toFixed(2));
	cartCost.total = total;
}


/**
 * 6. Submit cart data
 */
$('#checkout, #btnSubmitForm').click(function() {
	// console.log('checkout');
	// console.log(selectedItems);
	// console.log(cartCost);

	var cartData = {};
	cartData.items = selectedItems;
	cartData.cost = cartCost;

	// console.log(cartData);
	// console.log(JSON.stringify(cartData));
	$('#cartData').val(JSON.stringify(cartData));
});
